import React, { useEffect, useRef, useState, useMemo } from "react";
import { connect } from "react-redux";
import { SettingOutlined, HolderOutlined } from "@ant-design/icons";

import { Space, Drawer, Checkbox, message, notification } from "antd";
import { Row, Col } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useLocation, useParams } from "react-router-dom";

import "../../components/AccessManagement/AccessManagementListing/AccessManagement.css";

import {
  calculateAvailableColumnValue,
  calculateFixedColumnValue,
  generateAvailableColumns,
  generateColumnSeqeuenceNo,
  generateDefaultFieldArray,
  generateFixedColumns,
  generateSaveColumnListRequest,
} from "../PartnerManagement/PartnerManagementListing/helperFunction";

import UISectionHeading from "../../common/UiDrawerHeading/UiDrawerHeading";
import { getAddLeadMasterList } from "../../redux/AddLead/action";
import useSession from "../CustomLogout/useSession";
import MyServices from "../MyServices/MyServices";
import CustomLogout from "../CustomLogout/CustomLogout";
import UseFullLoader from "../FullPageLoader/UseFullLoader";
import useWindowSize from "../../utils/useWindowSize";
import {
  getCommonListing,
  getColumnsMaster,
  updateColumnsMaster,
  getDynamicTabs,
  getTabStatusCount,
  TabsActionButtonsList,
} from "../../redux/UserManagement/UserListingAction";

const AgeColumn = {
  dataType: "TEXT",
  fieldDisplayName: "Age",
  fieldId: 0,
  fieldName: "age",
  isDefault: true,
  isFixed: true,
  sequence: 0,
};

function UserManagementListing({
  partnerRefresh,
  setPartnerRefresh,
  ...props
}) {
  const handleSessionExpired = useSession();

  const TAB_NAME_MAPPING = useRef({});
  const { access_token, updateColumnsListData, roleId } = props;

  const [toggleState, setToggleState] = useState(1);

  const [listingData, setlistingData] = useState([]);

  const [columnsDto, setColumnsDto] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [selectedColumnsPrevState, setSelectedColumnsPrevState] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState("");
  const temp = useLocation();
  const leadDocument = temp?.state?.leadDocument;
  const [hiddenCols, setHiddenCols] = useState([]);
  const [listingMaster, setListingMaster] = useState("");
  const [fixedColumns, setFixedColumns] = useState([]);
  const [availableColumns, setAvailableColumns] = useState([]);
  const [columnsOrder, setColumnsOrder] = useState([]);
  const [visible, setVisible] = useState(false);
  const [status, setStatus] = useState("");

  const [searchMainData, setSearchMainData] = useState([]);
  const [searchColData, setSearchColData] = useState("");
  const [searchStatus, setSearchStatus] = useState(false);

  const [statusCount, setStatusCount] = useState(null);
  const [{ pageSize, pageIndex }, setPagination] = useState({
    pageSize: 10,
    pageIndex: 0,
  });

  const [tabIndex, setTabIndex] = useState(0);
  const [actionButtonData, setActionButtonData] = useState();

  const pagination = useMemo(
    () => ({
      pageSize,
      pageIndex,
    }),
    [pageSize, pageIndex]
  );

  const { width } = useWindowSize();

  const [loader, showLoader, hideLoader] = UseFullLoader();

  const getActionDataList = (selectedTab) => {
    props
      .getActionData({
        access_token,
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            const actionData = res?.data?.ACTION_BUTTON_DTO?.list;

            const actionDataList =
              actionData?.length > 0
                ? actionData?.filter(
                    (item) => item.partnerUserMasterTab === selectedTab
                  )
                : [];

            setActionButtonData(actionDataList);
          }
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          hideLoader();

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            hideLoader();

            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const getTabStatusCountData = () => {
    let params = {
      partnerFirmId: props.partnerFirmId,
    };
    props.getTabStatusCount({ access_token, params }).then((res) => {
      if (res.success?.status == 200) {
        let temp = {};
        let tabs = [];
        res.tabCaseCount.forEach((item) => {
          TAB_NAME_MAPPING.current = {
            ...TAB_NAME_MAPPING.current,
            [item.tab]: item.tabName,
          };
          temp[item.tab] = item.caseCount;
          tabs.push(item.tab);
        });

        let tabName = leadDocument ? tabs[1] : tabs[0];
        if (!partnerRefresh) {
          setSelectedTab(tabName);
          setToggleState(leadDocument ? 2 : 1);
        }
        setTabs([...tabs]);
        setStatusCount({
          nstpCount: res.nstpCaseCount,
          stpCount: res.stpCaseCount,
          ...temp,
        });
      }
      if (res?.data?.error || res.message) {
        const errorCode = res?.data?.error?.errorCode || res.errorCode;
        const errorMessage = res?.data?.error?.message || res.message;
        hideLoader();

        if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          hideLoader();

          handleSessionExpired();
        } else {
          notification.error({
            description: errorMessage,
            duration: 5,
            placement: "top",
          });
        }
      }
    });
  };

  const getApplicationList = (tabStatus) => {
    showLoader();
    props
      .getListing({
        access_token,
        sortField: "leadId",
        sortOrder: "desc",
        tabName: tabStatus,
        tab: selectedTab,
        searchData: searchMainData,
        pageSize,
        pageIndex,
        params: {
          partnerFirmId: props.partnerFirmId,
        },
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            setPartnerRefresh(false);
            const fields = res?.data?.userFieldsDto?.fields;
            hideLoader();
            // setTableLoader(false);
            let tempData = [];
            res?.data?.dtoList.forEach((item, index) => {
              let obj = { ...item };
              let currentDate = new Date();
              let difference = obj.createdOn - currentDate.getTime();
              let dayMilliSeconds = 1000 * 60 * 60 * 24;
              let hourMilliSeconds = 1000 * 60 * 60;
              obj.leadCrmID = item.leadCrmID;

              let days = Math.floor(Math.abs(difference / dayMilliSeconds));
              let hours = Math.floor(
                Math.abs(Math.abs(difference / hourMilliSeconds) % 24)
              );
              obj.age = `${days} Days ${hours} Hours`;
              tempData.push(obj);
            });
            setlistingData(tempData);
            setListingMaster(res?.data?.userFieldsDto?.listingMaster);
            setColumnsDto([AgeColumn, ...fields]);
            const fieldArray = generateDefaultFieldArray(fields);
            setSelectedColumns(fieldArray);
            setHiddenCols(fieldArray);
            setColumnsOrder(fieldArray);
            setFixedColumns(generateFixedColumns(fields));
            setAvailableColumns(generateAvailableColumns(fields));
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;
            hideLoader();

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              hideLoader();

              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      });
  };

  const toggleTab = (tab, index) => {
    setSelectedTab(tab);
    setToggleState(index);
    setSearchMainData([]);
    setPagination({
      // pageSize: 10,
      ...pagination,
      pageIndex: 0,
    });
  };

  const showDrawer = () => {
    setVisible(true);
    setSelectedColumnsPrevState(selectedColumns);
  };

  const onChange = (e) => {
    const { value, checked } = e.target;
    if (selectedColumns.includes(value)) {
      const newArray = selectedColumns.filter((values) => values !== value);
      setSelectedColumns(newArray);
    } else {
      setSelectedColumns((prevCols) => {
        if (!checked) return [...prevCols, value];
        else return [...prevCols];
      });
    }
  };

  const assignToMe = (row) => {};

  const handleRedirect = (row) => {};

  const searchSelectColumnName = (columnData) => {
    switch (columnData?.fieldName) {
      case "countryOfStudy":
        return "countryOfStudyId";

      case "leadPincode":
        return "leadPincodeId";

      case "currentSeUserName":
        return "currentSeUserId";

      case "currentSmUserName":
        return "currentSmUserId";

      case "assignedAvanseBranchName":
        return "assignedAvanseBranchId";

      default:
        return columnData?.fieldName;
    }
  };
  const handleToggleSort = (column, sortBy) => {
    showLoader();
    const columnData = columnsDto.find((ele) => ele.fieldId === column.id);
    props
      .getListing({
        access_token,
        sortField: searchSelectColumnName(columnData),
        sortOrder: sortBy,
        tabName: status,
        tab: selectedTab,
        searchData: searchMainData,
        params: {
          partnerFirmId: props.partnerFirmId,
        },
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            const fields = res?.data?.userFieldsDto?.fields;
            hideLoader();

            let tempData = [];
            res?.data?.dtoList.forEach((item, index) => {
              let obj = { ...item };
              let currentDate = new Date();
              let difference = obj.createdOn - currentDate.getTime();
              let dayMilliSeconds = 1000 * 60 * 60 * 24;
              let hourMilliSeconds = 1000 * 60 * 60;
              obj.leadCrmID = item.leadCrmID;

              let days = Math.floor(Math.abs(difference / dayMilliSeconds));
              let hours = Math.floor(
                Math.abs(Math.abs(difference / hourMilliSeconds) % 24)
              );
              obj.age = `${days} Days ${hours} Hours`;

              tempData.push(obj);
            });

            setlistingData(tempData);
            setListingMaster(res?.data?.userFieldsDto?.listingMaster);
            setColumnsDto([AgeColumn, ...fields]);
            const fieldArray = generateDefaultFieldArray(fields);
            setSelectedColumns(fieldArray);
            setHiddenCols(fieldArray);
            setColumnsOrder(fieldArray);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;
            hideLoader();

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              hideLoader();

              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      });
  };

  useEffect(() => {
    getTabStatusCountData();
  }, []);

  useEffect(() => {
    if (partnerRefresh) {
      getTabStatusCountData();
      message.destroy();
      getApplicationList(status);
    }
  }, [partnerRefresh]);

  useEffect(() => {
    if (selectedTab) {
      getActionDataList(selectedTab);
    }
  }, [selectedTab]);

  useEffect(() => {
    if (selectedTab && !partnerRefresh) {
      getApplicationList(status);
    }
  }, [pageIndex, pageSize, selectedTab]);

  useEffect(() => {
    if (searchMainData.length > 0) {
      showLoader();
      const columnData = columnsDto.find(
        (ele) => ele.fieldId === searchColData.id
      );

      props
        .getListing({
          access_token,
          sortField: searchSelectColumnName(columnData),
          sortOrder: searchColData.isSortedDesc ? "desc" : "asc",
          searchData: searchMainData,
          // searchData: [
          //   {
          //     search: `${value}`,
          //     searchCol: `${columnData.fieldName}`,
          //     searchType: "CONTAINS",
          //   },
          // ],

          // tabName: status,
          tab: selectedTab,
        })
        .then((res) => {
          if (res && res.status === 200) {
            const fields = res?.data?.userFieldsDto?.fields;
            hideLoader();

            let tempData = [];
            res?.data?.dtoList.forEach((item, index) => {
              let obj = { ...item };
              let currentDate = new Date();
              let difference = obj.createdOn - currentDate.getTime();
              let dayMilliSeconds = 1000 * 60 * 60 * 24;
              let hourMilliSeconds = 1000 * 60 * 60;
              obj.leadId = item.leadId;

              let days = Math.floor(Math.abs(difference / dayMilliSeconds));
              let hours = Math.floor(
                Math.abs(Math.abs(difference / hourMilliSeconds) % 24)
              );
              obj.age = obj.createdOn ? `${days} Days ${hours} Hours` : "NaN";

              tempData.push(obj);
            });

            setlistingData(tempData);
            setListingMaster(res?.data?.userFieldsDto?.listingMaster);
            setColumnsDto([AgeColumn, ...fields]);
            const fieldArray = generateDefaultFieldArray(fields);
            setSelectedColumns(fieldArray);
            setHiddenCols(fieldArray);
            setColumnsOrder(fieldArray);
          } else if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;
            hideLoader();

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              hideLoader();

              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
    } else {
      if (searchStatus) getApplicationList();
    }
  }, [searchMainData]);

  const onSearch = (value, column) => {
    const columnData = columnsDto.find((ele) => ele.fieldId === column.id);
    setSearchStatus(true);
    if (value !== "") {
      setSearchColData(column);

      const index = searchMainData.findIndex(
        (item) => item.searchCol === searchSelectColumnName(columnData)
      );

      if (index > -1) {
        setSearchMainData((prev) => {
          const temp = [...prev];
          temp[index].search = value;
          return temp;
        });
      } else {
        setSearchMainData((prev) => {
          const temp = [...prev];
          temp.push({
            search: `${value}`,
            searchCol: `${searchSelectColumnName(columnData)}`,
            searchType:
              columnData?.dataType === "DROPDOWN" ||
              columnData?.dataType === "SEARCH_DROPDOWN"
                ? "EQUAL"
                : "CONTAINS",
          });
          return temp;
        });
      }
    } else if (value === "" && searchMainData?.length > 0) {
      const index = searchMainData.findIndex(
        (item) => item.searchCol === searchSelectColumnName(columnData)
      );

      if (index > -1) {
        setSearchMainData((prev) => {
          const temp = [...prev];
          temp.splice(index, 1);
          return temp;
        });
      }
    }
    //  else {
    //   getApplicationList();
    // }
  };

  const onDrawerSubmit = (e) => {
    e.preventDefault();
    setVisible(false);
    saveColumnsList();
  };

  const handleCancel = () => {
    setSelectedColumns(selectedColumnsPrevState);
    setVisible(false);
  };

  const saveColumnsList = async () => {
    try {
      const updatedFixedColumns = calculateFixedColumnValue(fixedColumns);
      const updatedAvailableColumns =
        calculateAvailableColumnValue(availableColumns);
      const updatedColumns = generateColumnSeqeuenceNo([
        ...updatedFixedColumns,
        ...updatedAvailableColumns,
      ]);
      const userFields = generateSaveColumnListRequest(
        updatedColumns,
        selectedColumns,
        listingMaster,
        selectedTab
      );
      const response = await updateColumnsListData({
        userFields,
        access_token,
      });
      if (response && response.success && response.success.status === "200") {
        getApplicationList(status);
      }
    } catch (e) {}
  };

  const onDragColumn = (result) => {
    if (!result.destination) return;
    let itemSource = [];
    let itemDestination = [];
    let items = [];
    if (
      result.source.droppableId === "fixedColumns" &&
      result.destination.droppableId === "fixedColumns"
    ) {
      items = [...fixedColumns];
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);
      setFixedColumns(items);
    }
    if (
      result.source.droppableId === "availableColumns" &&
      result.destination.droppableId === "availableColumns"
    ) {
      items = [...availableColumns];
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);
      setAvailableColumns(items);
    }

    if (
      result.source.droppableId === "fixedColumns" &&
      result.destination.droppableId === "availableColumns"
    ) {
      itemSource = [...fixedColumns];
      itemDestination = [...availableColumns];
      const [reorderedItem] = itemSource.splice(result.source.index, 1);
      itemDestination.splice(result.destination.index, 0, reorderedItem);
      setAvailableColumns(itemDestination);
      setFixedColumns(itemSource);
    }
    if (
      result.source.droppableId === "availableColumns" &&
      result.destination.droppableId === "fixedColumns"
    ) {
      itemSource = [...availableColumns];
      itemDestination = [...fixedColumns];
      const [reorderedItem] = itemSource.splice(result.source.index, 1);
      itemDestination.splice(result.destination.index, 0, reorderedItem);
      setFixedColumns(itemDestination);
      setAvailableColumns(itemSource);
    }
  };

  return (
    <div>
      {props?.LogoutFlag?.logoutFlag ? <CustomLogout /> : ""}
      <div className="dashboard">
        <Drawer
          placement="right"
          width={width > 786 ? 400 : 300}
          onClose={handleCancel}
          open={visible}
        >
          <DragDropContext onDragEnd={onDragColumn}>
            <div className="header-sec-drawer">
              <UISectionHeading drawerHeading="Column Configuration" />
            </div>
            <br></br>
            <div>
              <h4>Fixed Columns</h4>
              <Droppable droppableId="fixedColumns">
                {(dropProps) => (
                  <ul
                    className="coloum-list"
                    {...dropProps.droppableProps}
                    ref={dropProps.innerRef}
                  >
                    {fixedColumns &&
                      fixedColumns.map((item, index) => (
                        <Draggable
                          key={index}
                          draggableId={`fixedCol-${index}`}
                          index={index}
                        >
                          {(dragProps) => (
                            <li
                              ref={dragProps.innerRef}
                              {...dragProps.draggableProps}
                              className="drag-item-container"
                            >
                              <Checkbox
                                onChange={onChange}
                                value={item.fieldId}
                                checked={
                                  !selectedColumns.includes(item.fieldId)
                                }
                              >
                                <span>{item.fieldDisplayName}</span>
                              </Checkbox>
                              <HolderOutlined
                                {...dragProps.dragHandleProps}
                                style={{ fontSize: 25, cursor: "move" }}
                              />
                            </li>
                          )}
                        </Draggable>
                      ))}
                    {dropProps.placeholder}
                  </ul>
                )}
              </Droppable>
            </div>
            <div>
              <h4>Available Columns</h4>
              <Droppable droppableId="availableColumns">
                {(dropProps) => (
                  <ul
                    className="coloum-list"
                    {...dropProps.droppableProps}
                    ref={dropProps.innerRef}
                  >
                    {availableColumns &&
                      availableColumns.map((item, index) => (
                        <Draggable
                          key={index}
                          draggableId={`availableCol-${index}`}
                          index={index}
                        >
                          {(dragProps) => (
                            <li
                              ref={dragProps.innerRef}
                              {...dragProps.draggableProps}
                              className="drag-item-container"
                            >
                              <Checkbox
                                onChange={onChange}
                                value={item.fieldId}
                                checked={
                                  !selectedColumns.includes(item.fieldId)
                                }
                              >
                                <span>{item.fieldDisplayName}</span>
                              </Checkbox>
                              <HolderOutlined
                                {...dragProps.dragHandleProps}
                                style={{ fontSize: 25, cursor: "move" }}
                              />
                            </li>
                          )}
                        </Draggable>
                      ))}
                    {dropProps.placeholder}
                  </ul>
                )}
              </Droppable>
              <Row style={{ display: "flex", justifyContent: "flex-end" }}>
                <button className="fixedcol-drwer-btn" onClick={handleCancel}>
                  Cancel
                </button>
                <button
                  className="fixedcol-drwer-btn-sbmit"
                  onClick={onDrawerSubmit}
                >
                  Apply
                </button>
              </Row>
            </div>
          </DragDropContext>
        </Drawer>

        <div
          className="site-card-wrapper"
          style={{ maxWidth: "100%", position: "relative" }}
        >
          <div style={{ paddingTop: "0px", maxWidth: "100%" }}>
            <Space direction={"vertical"} className="w-100">
              <Row style={{ maxWidth: "100%" }}>
                <Col style={{ paddingTop: 20 }}>
                  {width > 786 && (
                    <div className="block-tabs w-30 h-60px">
                      {tabs.map((item, index) => (
                        <button
                          className={
                            toggleState === index + 1
                              ? "tabs active-tabs"
                              : "tabs"
                          }
                          onClick={() => toggleTab(item, index + 1)}
                        >
                          {TAB_NAME_MAPPING.current[item]}
                          <span
                            className={
                              statusCount &&
                              (statusCount[item] >= 100000
                                ? "listCountMoreThan100000"
                                : statusCount[item] >= 10000
                                ? "listCountMoreThan10000"
                                : statusCount[item] >= 1000
                                ? "listCountMoreThan1000"
                                : statusCount[item] >= 100
                                ? "listCountMoreThan100"
                                : "listCount")
                            }
                          >
                            {" "}
                            {statusCount ? statusCount[item] : ""}
                          </span>
                        </button>
                      ))}
                    </div>
                  )}

                  {width < 786 && (
                    <div className="block-tabs-mobile">
                      <select
                        className="block-tabs-mobile-select"
                        onChange={(e) =>
                          toggleTab(
                            e.target.value,
                            tabs.indexOf(e.target.value) + 1
                          )
                        }
                        defaultValue={tabs[0]}
                      >
                        {tabs.length === 0 && (
                          <option value="">Select Tab</option>
                        )}
                        {tabs.map((item, index) => (
                          <option
                            value={item}
                            onClick={() => setTabIndex(index + 1)}
                          >
                            {TAB_NAME_MAPPING.current[item]}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {!loader && columnsDto && columnsDto.length > 0 && (
                    <button
                      className="Fixedcol-icon"
                      type="primary"
                      onClick={showDrawer}
                    >
                      <SettingOutlined />
                    </button>
                  )}

                  {loader}

                  <div className="content-tabs">
                    {tabs.map((item, index) => (
                      <div
                        className={
                          toggleState === index + 1
                            ? "content  active-content"
                            : "content"
                        }
                      >
                        <MyServices
                          domainData={listingData}
                          statusType={index + 1}
                          // get unqiue record of columnsDto
                          columnsData={
                            columnsDto?.length > 0
                              ? columnsDto?.filter(
                                  (v, i, a) =>
                                    a.findIndex(
                                      (t) => t.fieldId === v.fieldId
                                    ) === i
                                )
                              : columnsDto
                          }
                          hiddenColumns={hiddenCols}
                          columnsOrder={columnsOrder}
                          assignedToMe={assignToMe}
                          handleToggleSort={handleToggleSort}
                          handleRedirect={handleRedirect}
                          onSearch={onSearch}
                          actionDataList={actionButtonData}
                          pageTotalCount={
                            statusCount && statusCount[selectedTab]
                          }
                          pageIndex={pageIndex}
                          pageSize={pageSize}
                          setPagination={setPagination}
                          pagination={pagination}
                          setPartnerRefresh={setPartnerRefresh}
                          partnerRefresh={partnerRefresh}
                          selectedTab={selectedTab}
                        />
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
            </Space>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    getListing: (data) => dispatch(getCommonListing(data)),
    getColumnListData: (details) => dispatch(getColumnsMaster(details)),
    getDynamicTabs: (details) => dispatch(getDynamicTabs(details)),
    updateColumnsListData: (details) => dispatch(updateColumnsMaster(details)),

    getTabStatusCount: (data) => dispatch(getTabStatusCount(data)),
    getAddLeadMasterList: (data) => dispatch(getAddLeadMasterList(data)),
    getActionData: (data) => dispatch(TabsActionButtonsList(data)),
  };
};
const mapStateToProps = (state) => {
  return {
    access_token: state.auth.idToken,
    partnerFirmId:
      state?.auth?.partnerFirmDetails?.partnerFirmId ||
      state?.auth?.checkLogin?.partnerFirmDetails?.partnerFirmId ||
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId,
    LogoutFlag: state.Logout,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserManagementListing);
